import {loadStripe} from '@stripe/stripe-js'

// Initialize Stripe once and export it for reuse across the application
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

// Additional Stripe helper functions can be added here
